<script>
import SaleService from '@/services/sale';

export default {
  props: {
    sales: {
      type: Array,
      default: function() {
        return [];
      }
    },
  },
  data() {
    return {
      fields: [
        { key: 'code', sortable: false, label: '#' },
        { key: 'customer', sortable: false, label: 'Cliente' },
        { key: 'date', sortable: false, label: 'Data/Hora', formatter: (value) => {
            return this.$moment(value).format('DD/MM/YYYY HH:mm:ss');
        } },
        { key: 'statusDescription', sortable: false, label: 'Status' },
        { key: 'shipping', sortable: false, label: 'Entrega' },
        { key: 'payment', sortable: false, label: 'Pagamento', formatter: (value) => {
          return value.payment_option ? value.payment_option.description : ''
        } },
        { key: 'total_value', sortable: false, label: 'Valor do Pedido', formatter: (value) => {
          return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        } },
        { key: 'actions', label: 'Ações', class: 'nowrap-col' }
      ],
    };
  },
  methods: {
    formatDate(date) {
      return this.$moment(date).format('DD/MM/YYYY');
    },
    download(item) {
      SaleService.downloadSale(item._id).then(res => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', `pedido-${item.code}.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        this.$toast.error('Não foi possível fazer o download do pedido');
      })
    }
  }
};
</script>

<template>
  <div class="table-responsive mb-0">
     <b-table
      show-empty
      emptyText="Nenhum registro para exibir"
      :items="sales"
      :fields="fields"
      responsive="sm"
      head-variant="light"
    >
      <template v-slot:cell(statusDescription)="row">
        <span
          class="badge badge-pill badge-soft-primary font-size-12"
          :class=" {
            'badge-soft-danger': row.item.status === 'canceled',
            'badge-soft-success': row.item.status === 'new',
            'badge-soft-secondary': row.item.status === 'completed',
          }"
        >{{row.item.statusDescription}}</span>
      </template>

      <template v-slot:cell(customer)="row">
        {{row.item.customer.name ? row.item.customer.name : 'Nome do Cliente'}}
        <span v-if="row.item.tags && row.item.tags.first_sale" class="badge badge-pill badge-soft-primary font-size-10">Primeira Compra</span>
      </template>

      <template v-slot:cell(shipping)="row">
        {{row.item.shipping.shipping_option ? row.item.shipping.shipping_option.description : ''}}
        <p v-if="row.item.shipping.schedule" class="text-muted mb-0 mt-1 font-size-10">{{formatDate(row.item.shipping.schedule.date)}} {{row.item.shipping.schedule.description}}</p>
      </template>

      <template v-slot:cell(actions)="row">
        <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
          <template v-slot:button-content>
            <i class="mdi mdi-dots-horizontal font-size-18"></i>
          </template>

          <router-link :to="'/sales/detail/' + row.item._id">
            <b-dropdown-item href="javascript: void(0);">
              <i class="fas fa-shopping-cart text-primary mr-2 mt-2"></i>
              Detalhes do Pedido
            </b-dropdown-item>
          </router-link>

          <b-dropdown-item v-b-modal.modal-remove @click="download(row.item)">
            <i class="fas fa-download text-info mr-2 mt-2"></i> Via do Pedido (PDF)
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
  </div>  
</template>